import { getError } from "@/utils/helpers";
import ColorService from "@/services/maintain/ColorService";

export const namespaced = true;

export const state = {
  colors: [],
  loading: false,
  error: null,
};

export const mutations = {
  SET_COLORS(state, colors) {
    state.colors = colors;
  },
  SET_LOADING(state, loading) {
    state.loading = loading;
  },
  SET_ERROR(state, error) {
    state.error = error;
  },
};

export const actions = {
  getMains({ commit }, Id) {
    commit("SET_LOADING", true);

    ColorService.getMains(Id)
      .then((response) => {
        commit("SET_COLORS", response.data.data);
      })
      .catch((error) => {
        commit("SET_LOADING", false);
        commit("SET_ERROR", getError(error));
      })
      .finally(() => {
        commit("SET_LOADING", false);
      });
  },
  setDefault({ commit }) {
    commit("SET_LOADING", false);
    commit("SET_ERROR", null);
    commit("SET_COLORS", []);
  },
};
export const getters = {
  colors: (state) => {
    return state.colors;
  },
  loading: (state) => {
    return state.loading;
  },
  error: (state) => {
    return state.error;
  },
};
